import { getRibbonText, RibbonTypeEnum } from '@components/ProductBanner/helpers';
import { ProductProps } from '@repo/ui/src/types';
import { classNames } from '@repo/ui/src/utils/classNames';
import useTranslation from '@repo/ui/src/context/Translation/useTranslation';
import React from 'react';

export interface ProductBannerProps {
  product: ProductProps;
  renderEmpty?: boolean;
  outOfStockText?: string;
  saleText?: string;
  newText?: string;
  comingSoonText?: string;
  className?: string;
}

const ProductBanner = ({
  product,
  outOfStockText,
  saleText,
  newText,
  comingSoonText,
  renderEmpty = false,
  className,
}: ProductBannerProps) => {
  const { t } = useTranslation();
  const _outOfStockText =
    outOfStockText ??
    t('productDetailPageContent.outOfStockText', undefined, { default: 'Out of Stock' });
  const _saleText =
    saleText ?? t('productDetailPageContent.saleText', undefined, { default: 'On Sale' });
  const _newText = newText ?? t('productDetailPageContent.newText', undefined, { default: 'New' });
  const _comingSoonText =
    comingSoonText ??
    t('productDetailPageContent.comingSoonText', undefined, { default: 'Coming Soon' });

  const RIBBON_STYLE = React.useMemo(
    () => ({
      [_outOfStockText || RibbonTypeEnum.OutOfStock]: 'tw-bg-text-300',
      [_saleText || RibbonTypeEnum.Sale]: 'tw-bg-action-500',
      [RibbonTypeEnum.FreeBundle]: 'tw-bg-surface-500',
      [_newText || RibbonTypeEnum.New]: 'tw-bg-action-500',
      [_comingSoonText || RibbonTypeEnum.ComingSoon]: 'tw-bg-surface-500',
    }),
    [_newText, _outOfStockText, _saleText],
  );
  const ribbonText = getRibbonText(product, _newText, _saleText, _outOfStockText, _comingSoonText);
  if (!ribbonText && !renderEmpty) return null;
  return (
    <div
      className={classNames(
        'tw-flex tw-items-center tw-px-6 tw-relative tw-py-2',
        ribbonText && RIBBON_STYLE[ribbonText],
        className,
      )}
    >
      <h6
        className={classNames(
          'tra-text-web-heading tw-text-lg tw-text-white tw-mb-0 tw-text-center',
        )}
      >
        {ribbonText}
      </h6>
    </div>
  );
};

export default ProductBanner;
